<template>
  <div class="approval-wrap">
    <div class="approval-box">
      <img
        class="approval-image"
        height="40"
        src="~@/presentationals/v1/assets/images/payment-in-progress@2x.png"
        width="120"
      />
      <p class="approval-text">잠시만 기다려주세요</p>
      <i class="process-spin"></i>
    </div>
  </div>
</template>

<script>
import { enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'Approval',
  created() {
    this.paymentId = this.$route.params.paymentId
    this.fetchApproval()
  },
  data() {
    return {
      paymentId: null,
      targetElement: null
    }
  },
  mounted() {
    this.targetElement = document.getElementsByClassName('v--modal-overlay')
  },
  methods: {
    fetchApproval() {
      this.$http
        .post(`/v1/payment/approval/${this.paymentId}`)
        .then(response => {
          window.location.replace(response.data.result)
        })
        .catch(error => {
          this.$customAlert(error.response.data.result, () => {
            enableBodyScroll(this.targetElement)
            this.$closeWebView
          })
        })
    }
  }
}
</script>

<style scoped>
.approval-wrap {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
}

.approval-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 130px;
  width: 100%;
  padding: 8px 0 9px;
}

.approval-text {
  margin-top: 12px;
  height: 23px;
  object-fit: contain;
  font-size: 18px;
  line-height: 1.28;
  letter-spacing: -0.5px;
  text-align: center;
}

.process-spin {
  margin-top: 15px;
  height: 19px;
  width: 19px;
  border-radius: 50%;
  border: 5px solid;
  border-color: transparent #bbbbbb #bbbbbb;
  transform: rotate(-45deg);
  animation: spinAround 1s infinite linear;
}
</style>
